const faqItems = [
  {
    id: 1,
    question: '日韩影视网的剧集资源是否免费？',
    answer: '是的，日韩影视网所有剧集资源均免费在线观看，无需付费订阅。我们通过广告收入维持平台运营，为用户提供持续稳定的高清观影服务。',
  },
  {
    id: 2,
    question: '剧集更新速度如何？能看到最新播出的日韩剧吗？',
    answer: '我们与日韩播出进度保持高度同步，大部分热门剧集在播出后24小时内即可上线中文字幕版本。每日更新30+部剧集，确保您不错过任何精彩内容。',
  },
  {
    id: 3,
    question: '支持哪些设备观看？画质最高支持多少？',
    answer: '日韩影视网全面支持电脑、平板和手机端在线观看，无需下载任何插件或APP。所有剧集最高支持1080P全高清画质，并可根据网络状况自动调整清晰度，确保流畅不缓冲。',
  },
  {
    id: 4,
    question: '如何搜索我想看的日剧或韩剧？',
    answer: '您可以使用首页顶部的搜索功能，输入剧名、演员名或关键词即可快速找到对应剧集。同时我们还提供分类浏览、排行榜和个性化推荐，帮助您发现更多好剧。',
  },
  {
    id: 5,
    question: '字幕翻译质量怎么样？支持哪些语言？',
    answer: '我们的字幕团队由资深日韩语翻译组成，确保翻译准确流畅。目前主要提供简体中文字幕，部分热门剧集也提供繁体中文字幕版本。',
  },
  {
    id: 6,
    question: '遇到播放问题或资源缺失该怎么办？',
    answer: '如遇播放卡顿，建议检查网络连接或切换清晰度。如发现资源缺失，欢迎通过"联系我们"页面的投稿邮箱反馈，我们会在24小时内处理您的请求。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            关于日韩影视网的使用、资源和功能，这里有你想要的答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none hover:bg-background-200/50 transition-colors duration-200">
                <h3 className="text-sm font-semibold text-foreground-950 pr-4">
                  {item.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 transition-colors duration-200">
                  <i className="ri-arrow-down-s-line text-sm text-foreground-600 group-open:text-primary-600 transition-transform duration-200 group-open:rotate-180"></i>
                </span>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}